import { createSelector } from "reselect"

const platform = state => state.platform

export const selectCurrentVersion = createSelector(
  [platform],
  platform => platform?.currentVersion
)
